import { getField, updateField } from 'vuex-map-fields'
import Line from './line'
import api from '../api/api'

export const namespaced = true

let baseUrl = '/phreatic_lines/'

const line = new Line(baseUrl)

const getDefaultState = () => {
  return {
    ...structuredClone(line.state),
    cutDryTornZoneDialog: false,
    cutDryTornZoneLoading: false,
    color: 'blue',
    dash: 'dot',
    name: 'Phreatic Line',
    storeNamespace: 'phreaticLine'
  }
}

export const state = getDefaultState()

export const mutations = {
  ...line.mutations,
  TOGGLE_CUT_DRY_TORN_ZONE_LOADING(state) {
    state.cutDryTornZoneLoading = !state.cutDryTornZoneLoading
  },
  TOGGLE_CUT_DRY_TORN_ZONE_DIALOG(state) {
    state.cutDryTornZoneDialog = !state.cutDryTornZoneDialog
  },
  updateField
}

export const actions = {
  ...line.actions,
  async generate(context) {
    context.commit('TOGGLE_GENERATE_LOADING')
    const id = context.rootGetters['stabSchematisationStage/currentStabSchematisationStageId']
    const riverWaterLevel = context.rootGetters['multiplePhreaticLine/getRiverWaterLevel']
    const polderWaterLevel = context.rootGetters['multiplePhreaticLine/getPolderWaterLevel']
    const bulging = context.rootGetters['multiplePhreaticLine/getBulging']
    const currentMultiplePhreaticLine = context.rootState.multiplePhreaticLine.currentItem
    const url = baseUrl + id + '/generate/'
    try {
      let response = await api.post(url, {
        river_water_level: riverWaterLevel,
        polder_water_level: polderWaterLevel,
        bulging: bulging,
        properties: { multiple_phreatic_line: currentMultiplePhreaticLine.id }
      })
      await context.dispatch('replaceLine', response)
      const compositionId = response.data.properties.soil_composition
      await context.dispatch('soilLayer/fetchItems', compositionId, { root: true })
      context.commit('statePoints/SET_ITEMS', [], { root: true })
      context.commit('TOGGLE_GENERATE_LOADING')
    } catch (e) {
      console.log(e)
      context.commit('TOGGLE_GENERATE_LOADING')
      return false
    }
    return true
  },
  async cutDryTornZone(context) {
    context.commit('TOGGLE_CUT_DRY_TORN_ZONE_LOADING')
    const stabSchematisationStageId =
      context.rootGetters['stabSchematisationStage/currentStabSchematisationStageId']
    const url = baseUrl + stabSchematisationStageId + '/cut_dry_torn_zone/'
    const currentMultiplePhreaticLine = context.rootState.multiplePhreaticLine.currentItem
    try {
      const depthDryTornZone = context.rootGetters['multiplePhreaticLine/getDepthDryTornZone']
      let response = await api.post(url, {
        depth_dry_torn_zone: depthDryTornZone,
        properties: { multiple_phreatic_line: currentMultiplePhreaticLine.id }
      })
      await context.dispatch('replaceLine', response)
      const compositionId = response.data.properties.soil_composition
      await context.dispatch('soilLayer/fetchItems', compositionId, { root: true })
      context.commit('statePoints/SET_ITEMS', [], { root: true })
      context.commit('TOGGLE_CUT_DRY_TORN_ZONE_LOADING')
    } catch (e) {
      console.log(e)
      context.commit('TOGGLE_CUT_DRY_TORN_ZONE_LOADING')
      return false
    }
    return true
  },
  async update(context) {
    context.commit('TOGGLE_LOADING')
    const currentItem = context.state.currentItem
    let url = baseUrl + `${currentItem['id']}/`
    const response = await api.patch(url, currentItem)
    context.commit('SET_CURRENT_ITEM', response.data)
    context.commit('SET_DELETED_ITEM', {
      ...structuredClone(response.data)
    })
    context.commit('SET_COORDINATE')
    context.commit('SET_DELETED_COORDINATE')
    context.commit('EMPTY_DIRTY_OBJECT')
    context.commit('TOGGLE_LOADING')

    const compositionId = response.data.properties.soil_composition
    await context.dispatch('soilLayer/fetchItems', compositionId, { root: true })
    context.commit('statePoints/SET_ITEMS', [], { root: true })
  },
  toggleDryTornZoneDialog(context) {
    context.commit('TOGGLE_CUT_DRY_TORN_ZONE_DIALOG')
  }
}

export const getters = {
  ...line.getters,
  getField,
  getCurrentGeometry: (state) => {
    return state.currentItem?.geometry
  }
}
